<template>
  <div class="room-doc-list-component" data-grm-comp="ListDetail">
    <ul class="room-doc-list">
      <li v-for="(docPage, i) in roomDocFile.pages"
          :key="docPage.docPageId"
          class="room-doc-item"
          :class="[
            { selected: docPage.docPageId === roomDocFile.currDocPageId }
          ]">
        <div class="room-doc-select-button" @click="setCurrentPage(docPage.docPageId)"></div>
        <div class="room-doc-page">
          <p class="room-doc-page-number">{{ i + 1 }}</p>
          <lazy-component class="room-doc-thumb pre"
              @show="loadPageThumbnail(docPage, $event)"
          >
            <img>
          </lazy-component>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: 'RoomDocListDetail',
  computed: {
    ...mapGetters('doc', [
        'roomDoc',
        'getRoomDocFile'
    ]),
    roomDocFile() {
      return this.getRoomDocFile({
        roomGroupId: this.roomDoc.roomGroupId,
        docId: this.roomDoc.docId
      });
    }
  },
  watch: {
    'roomDocFile.currDocPageId': function() {
      this.$nextTick(() => {
        const roomDocItem = document.querySelector('[data-grm-comp="ListDetail"] .room-doc-item.selected')
        if (!roomDocItem) {
          return;
        }

        // const { offsetTop, offsetHeight } = roomDocItem;
        // const { scrollTop, offsetHeight: listHeight } = this.$parent.$parent.$refs.docListDetailScrollbar.$el;
        //
        // if (offsetTop < scrollTop) {
        //   // 페이지가 위에 있을 때
        //   this.$parent.$parent.$refs.docListDetailScrollbar.$el.scrollTop = offsetTop - 16;
        // } else if (offsetTop + offsetHeight > scrollTop + listHeight) {
        //   // 페이지가 아래에 있을 때
        //   this.$parent.$parent.$refs.docListDetailScrollbar.$el.scrollTop = offsetTop + offsetHeight - listHeight + 16;
        // }
        const scrollEl = this.$parent.$parent.$refs.docListDetailScrollbar.$el;
        let scrollTopMin = roomDocItem.offsetTop - scrollEl.clientHeight + roomDocItem.clientHeight;
        let scrollTopMax = roomDocItem.offsetTop;
        let scrollTop = scrollEl.scrollTop;
        if(scrollTop < scrollTopMin || scrollTop > scrollTopMax){
            let min = Math.abs(scrollTop - scrollTopMin);
            let max = Math.abs(scrollTop - scrollTopMax);

            let value = (min < max) ? scrollTopMin : scrollTopMax;
            scrollEl.scrollTop = value;
        }
      })
    }
  },
  methods: {
    ...mapActions('doc', [
      'changeRoomDocPage',
      'getRoomDocUrl',
    ]),
    async loadPageThumbnail(page, $comp) {
      let roomDocFile = this.roomDocFile;
      let url = await this.getRoomDocUrl({
        roomGroupId: roomDocFile.roomGroupId,
        docId: roomDocFile.docId,
        docPageId: page.docPageId,
        thumbnail: true
      });
      if($comp?.$el?.querySelector('img')){
        let img = $comp.$el.querySelector('img');
        if(img.src !== url){
          img.src = url;
          img.addEventListener('load', e => {
            $comp.$el.classList.remove('pre');
          }, {once: true});
        }
      }
      return url;
    },
    async setCurrentPage(pageId) {
      await this.changeRoomDocPage({
        roomGroupId: 'default',
        docId: this.roomDocFile.docId,
        docPageId: pageId
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.room-doc-list-component {}
.room-doc-list {
  display: flex;
  flex-direction: column;
  gap: 16px 0;
}
.room-doc-item {
  width: 100%;
  position: relative;
  cursor: pointer;
  &.selected {
    .room-doc-page-number {
      color: #09f;
    }
    .room-doc {
      border: 4px solid #09f !important;
    }
    .room-doc-title {
      color: #09f;
    }
    .room-doc-thumb {
      border: 4px solid #09f;
    }
  }
  &:hover {
    .room-doc {
      border: 1px solid #46cff3;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2)
    }
    .room-doc-title {
      color: #09f;
    }
  }
}

.room-doc-thumb {
  width: 100%;
  height: 100%;
  box-shadow: 0.5px 1px #ccc;

  &.pre {
    height: 70px;
    background-color: #dadada;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.room-doc {
  height: 56px;
  border: 1px solid #ccc;
  background-color: #fff;
  position: relative;
  pointer-events: none;
  transition: 0.1s ease-out;
}
.room-doc-select-button {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.room-doc-page {
  margin-bottom: 4px;
}
.room-doc-page-number {
  font-size: 10px;
  color: #666;
  transition: 0.1s ease-out;
}
.room-doc-title-wrapper {
  margin-top: 4px;
  text-align: center;
}
.room-doc-title {
  font-size: 10px;
  color: #999;
  line-height: 1.4;
  transition: 0.1s ease-out;
  pointer-events: none;
  word-break: break-all;
}
.room-doc-progress {
  width: 100%;
  margin-top: 6px;
  border-radius: 4px;
  background-color: #fff;
  position: relative;
  overflow: hidden;
}
.room-doc-progress-bar {
  background-color: #59f;
  position: absolute;
  inset: 0 auto 0 0;
  transition: 0.1s ease-out;
}
.room-doc-progress-text {
  font-size: 10px;
  text-align: center;
  line-height: 20px;
  position: relative;
}
.room-doc-button-wrapper {
  position: absolute;
  top: 0;
  right: 0;

  .grm-menu-component {
    position: absolute;
    top: 100%;
    right: 0;
  }
}
.room-doc-button {
  width: 30px;
  height: 24px;
  background: url('~@/assets/images/more_gray.svg') no-repeat center / 16px auto;
  transition: 0.1s ease-out;

  &:hover {
    background: $mainColor url('~@/assets/images/more_white.svg') no-repeat center / 16px auto;
  }
}
</style>